var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCmeal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 492 431",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #83b542;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_002-meal",
    "data-name": "002-meal",
    transform: "translate(0 -30.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    className: "cls-1",
    d: "M491,145.5l-41,316H314l-40-317H440l33-114,19,6-32,109Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    className: "cls-1",
    d: "M255,328.5V324q0-2.5-3-9.5a36.221,36.221,0,0,0-9-12.5q-6-5.5-20-10t-34-4.5H77q-20,0-34,4t-19.5,10a70.366,70.366,0,0,0-9,12q-3.5,6-3.5,11l1,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    className: "cls-1",
    d: "M12,420.5a6.814,6.814,0,0,0-.5,4.5,84.4,84.4,0,0,0,3,9.5A31.02,31.02,0,0,0,23,447q6,5.5,20,10t34,4.5H189q20,0,34-4t20-10a47.008,47.008,0,0,0,9-12,24.891,24.891,0,0,0,3-11v-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    className: "cls-1",
    d: "M244,400.5q9,0,15-7.5t6-18.5q0-11-6-18.5t-15-7.5H21q-9,0-15,7.5T0,374.5q0,11,6,18.5t15,7.5Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCmeal);
export default __webpack_public_path__ + "static/media/cmeal.77b080b1690719a3d4225b47cf0ee0ea.svg";
export { ForwardRef as ReactComponent };